import { z } from "zod"

export const WebphoneMessageActionSchema = z.enum(["c2cSmartPlaceCall", "c2cSmartSendSms"])
export type TWebphoneMessageAction = z.infer<typeof WebphoneMessageActionSchema>

export const WebphoneMessageSchema = z.object({
  from: z.literal("ringio-parent-window"),
  action: WebphoneMessageActionSchema,
  data: z.object({
    dstNumber: z.string(),
    To: z.string(),
    remoteId: z.string().optional(),
    remoteType: z.string().optional(),
    srcPersonId: z.number().optional(),
    origin: z.string(),
  }),
})
export type TWebphoneMessage = z.infer<typeof WebphoneMessageSchema>
